import React from 'react';

export const AccountManagementComponent: React.FC<any> = () => (
  <h1>Account Management</h1>
);
